<template>
  <div class="m-wrap m-pc">
    <Logo />
    <Banner />
    <div class="wrap-info">
      <!--提交成功-->
      <SuccessCon
        :platform="platform"
        v-if="!signSuccess && (isRefuse == '0' || isRefuse == null)"
      />

      <!--审核未通过-->
      <RefuseCon
        :platform="platform"
        v-if="!signSuccess && isRefuse != '0' && isRefuse != null"
      />

      <!--报名成功-->
      <SuccessPartCon :platform="platform" v-if="signSuccess" />

      <Meeting :seminarInfo="seminarInfo" />
    </div>
  </div>
</template>

<script>
import Logo from "@/components/Logo.vue";
import Banner from "@/components/Banner.vue";
import SuccessCon from "@/components/SuccessCon.vue";
import SuccessPartCon from "@/components/SuccessPartCon.vue";
import RefuseCon from "@/components/RefuseCon.vue";
import Meeting from "@/components/Meeting.vue";
import mixinConfig from "../../mixin/config.js";
import mixinMeeting from "../../mixin/meeting.js";
import mixinSuccess from "../../mixin/success.js";
export default {
  name: "PcSuccess",
  mixins: [mixinConfig, mixinMeeting, mixinSuccess],
  components: {
    Logo,
    Banner,
    SuccessCon,
    SuccessPartCon,
    RefuseCon,
    Meeting,
  },
  data() {
    return {
      platform: "pc",
      visible: false,
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
    },
  },
};
</script>
